import { render, staticRenderFns } from "./MaterialCreateEdit.vue?vue&type=template&id=4bbafcff&"
import script from "./MaterialCreateEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports